export default __webpack_public_path__ + "static/media/dexcom-green-standalone.eeef5199.png";